import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  Grid,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import Card from "@mui/material/Card";
import WarehouseLocationVm from "../viewmodel/WarehouseLocationVm";
import CBackDrop from "../../../basecomp/components/CBackDrop";
import { Box, styled, useMediaQuery, useTheme } from "@mui/system";
import { useNavigate } from "react-router-dom";
import CAuthPopUpBox from "../../../basecomp/components/CAuthPopUpBox";
import CAccordion from "../../../basecomp/components/CAccordion";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import { useTranslation } from "react-i18next";
import CButton from "../../../basecomp/components/CButton2";
import CameraAltIcon from "@mui/icons-material/AddAPhoto";
import PreviewIcon from "@mui/icons-material/Preview";
import PrintingVM from "../viewmodel/PrintingVM";
import CCarousel from "../../../basecomp/components/CCarousel";

const commonFontSize = ".9em";


const WareHouseView = () => {
  const {
    wareHouseMaterialData,
    infoMatHeadData,
    terminal_id,
    storage_loc,
    warehouseLoading,
    storage_bin,
    gsOneToolRedirectMethod,
    popUpBox,
    url_terminal,
    handleImageClick,
    openCarousel,
    carouselImages,
    setOpenCarousel,
  } = WarehouseLocationVm();

  // const {
  //  handleImageClick,
  //  openCarousel,
  //  carouselImages,
  //  setOpenCarousel,
  // } = PrintingVM();

  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const [assetData, setAssetData] = useState([]);
  const [infoRowData, setInfoRowData] = useState([]);
  const navigate = useNavigate()
  const [openImageModal, setOpenImageModal] = useState(null);
  const [selectedImages, setSelectedImages] = React.useState({});
  // const theme = useTheme();

  const isMobileOrTablet =
    useMediaQuery(
      theme.breakpoints.down("md")
    );
  const handleFileChange = (event, rowIndex) => {
    const files = Array.from(event.target.files);

    setSelectedImages((prev) => ({
      ...prev,
      [rowIndex]: files, // use unique row id
    }));
  };


  const OrderBoxText = styled("div")({
    textAlign: "center",
    backgroundColor: "#3CB043",
    color: "white",
    padding: ".5em",
    borderRadius: "0.7em 0.7em 0em 0em",
    fontSize: isXs ? ".9em" : "1.2em",
  });
  useEffect(() => {
    if (storage_loc === "1120" && url_terminal === "1260") {
      navigate(`/warehouse/whs-location-info?terminal_id=1121&storage_bin=${storage_bin}&storage_loc=${storage_loc}`);
      return;
    }

    if (
      url_terminal !== "null" &&
      storage_bin !== "null" &&
      storage_loc !== "null"
    ) {
      const effectiveTerminalId = (url_terminal === "1260" && storage_loc === "1120") ? "1121" : url_terminal;
      sessionStorage.setItem(
        "logingsoneurl",
        `/warehouse/whs-location-info?terminal_id=${effectiveTerminalId}&storage_bin=${storage_bin}&storage_loc=${storage_loc}`
      );
    }
  }, []);

  const handleCount = () => {
    navigate(
      `/warehouse/whs-location-info/counting?terminal_id=${terminal_id}&storage_bin=${storage_bin}&storage_loc=${storage_loc}`
    );
  };
  useEffect(() => {
    setAssetData([
      [
        {
          name: t("plant"),
          value: terminal_id,
        },
      ],
      [
        {
          name: t("str_loc"),
          value: storage_loc,
        },
      ],
      [
        {
          name: t("str_bin_grp"),
          value: storage_bin,
        },
      ],
    ]);
    setInfoRowData([
      { value: `name`, type: "T" },
      { value: `value`, type: "T" },
    ]);
  }, [terminal_id, storage_loc, storage_bin, i18n.language]);

  return (
    <Grid
      item
      xs={10}
      sm={10}
      md={10}
      lg={10}
      xl={10}
      sx={{ margin: "1em 0.5em 0.5em 0.5em" }}
    >
      {!(url_terminal == terminal_id) && popUpBox ? (
        <CAuthPopUpBox CText={t('unauth')} />
      ) : null}
      {popUpBox ? (
        <CAuthPopUpBox CText={t('unauth')} />
      ) : null}
      <CBackDrop cOpen={warehouseLoading} />
      <Card sx={{ padding: "0.5em" }}>
        <div
          style={{ display: "flex", justifyContent: "end", alignItems: "end" }}
        >
          <Tooltip title={t("start_counting_msg")}>
            <IconButton
              id="counting"
              style={{
                backgroundColor: wareHouseMaterialData?.length === 0 ? "#B0B0B0" : "#052660",
                color: "#FFFFFF",
                borderRadius: 5,
                padding: "8px",
              }}
              onClick={handleCount}
              disabled={wareHouseMaterialData?.length === 0}
            >
              <FactCheckOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
        <CAccordion
          CHeader={t("general_info")}
          CData={assetData}
          CRows={infoRowData}
        />

        <OrderBoxText>{t("inventory_details")}</OrderBoxText>
        <Box
          sx={{
            border: "1px solid #3CB043",
            borderRadius: "0 0 1em 1em",
            overflowX: "auto",
            whiteSpace: "nowrap",
            marginBottom: "3em",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          <Table sx={{ minWidth: "650px" }}>
            <TableHead>
              <TableRow>
                {infoMatHeadData.map((header, index) => (
                  <TableCell
                    key={index}
                    sx={{
                      fontWeight: "bold",
                      padding: "6px 24px",
                      fontSize: commonFontSize,
                    }}
                  >
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {wareHouseMaterialData?.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  {Object.keys(row).map((colKey, colIndex) => (
                    <TableCell
                      key={colIndex}
                      sx={{ padding: "8px 24px", fontSize: commonFontSize }}
                    >
                      {colKey === "material_no" ? (
                        <Tooltip title={t("resolver_tool")}>
                          <button
                            onClick={() =>
                              gsOneToolRedirectMethod(row.material_no)
                            }
                            style={{
                              background: "none",
                              border: "none",
                              color: "blue",
                              textDecoration: "underline",
                              cursor: "pointer",
                              padding: "0",
                              fontSize: "inherit",
                              fontFamily: "inherit",
                            }}
                          >
                            {row[colKey]}
                          </button>
                        </Tooltip>
                      ) : colKey === "image_link" ? (
                        <>

                          {row.image_link.length !== 0 ? <CButton
                            cSrc={<PreviewIcon />}

                            cOnClick={() =>
                              handleImageClick(row)
                            }
                          />
                            :
                            // <><IconButton
                            //   component="span"
                            //   onClick={() => {
                            //     const fileInput =
                            //       document.getElementById(`image-id-${rowIndex}`);

                            //     if (fileInput) {
                            //       fileInput.click();
                            //     }
                            //   }}
                            // >
                            //   <CameraAltIcon color="primary" />

                            //   <input
                            //     id={`image-id-${rowIndex}`}
                            //     type="file"
                            //     accept="image/*"
                            //     capture="environment"
                            //     onChange={(e) =>
                            //       handleFileChange(e, rowIndex)
                            //     }
                            //     style={{ display: "none" }}
                            //     multiple
                            //   />
                            // </IconButton>

                            // {selectedImages[rowIndex] && (
                            //   <Button
                            //     variant="contained"
                            //     size="small"
                            //     onClick={() =>
                            //       handleImageClick(row,selectedImages[rowIndex])
                            //     }
                            //     sx={{ fontSize: 10 }}
                            //   >
                            //     Upload
                            //   </Button>
                            // )}</>
                            <>
                              {/* CAMERA ICON */}
                              <IconButton
                                component="span"
                                onClick={() => {
                                  // MOBILE + TABLET
                                  if (isMobileOrTablet) {
                                    setOpenImageModal(rowIndex);
                                  }

                                  // LAPTOP + DESKTOP
                                  else {
                                    document
                                      .getElementById(
                                        `gallery-input-${rowIndex}`
                                      )
                                      ?.click();
                                  }
                                }}
                              >
                                <CameraAltIcon color="primary" />
                              </IconButton>

                              {/* CAMERA INPUT */}
                              <input
                                id={`camera-input-${rowIndex}`}
                                type="file"
                                accept="image/*"
                                capture="environment"
                                onChange={(e) =>
                                  handleFileChange(e, rowIndex)
                                }
                                style={{ display: "none" }}
                                multiple
                              />

                              {/* GALLERY INPUT */}
                              <input
                                id={`gallery-input-${rowIndex}`}
                                type="file"
                                accept="image/*"
                                onChange={(e) =>
                                  handleFileChange(e, rowIndex)
                                }
                                style={{ display: "none" }}
                                multiple
                              />

                              {/* MODAL ONLY FOR MOBILE/TABLET */}
                              {isMobileOrTablet && (
                                <Dialog
                                  open={openImageModal === rowIndex}
                                  onClose={() => setOpenImageModal(null)}
                                >
                                  <DialogTitle>
                                    Select Option
                                  </DialogTitle>

                                  <List>
                                    {/* CAMERA OPTION */}
                                    <ListItemButton
                                      onClick={() => {
                                        document
                                          .getElementById(
                                            `camera-input-${rowIndex}`
                                          )
                                          ?.click();

                                        setOpenImageModal(null);
                                      }}
                                    >
                                      <ListItemText primary="Open Camera" />
                                    </ListItemButton>

                                    {/* GALLERY OPTION */}
                                    <ListItemButton
                                      onClick={() => {
                                        document
                                          .getElementById(
                                            `gallery-input-${rowIndex}`
                                          )
                                          ?.click();

                                        setOpenImageModal(null);
                                      }}
                                    >
                                      <ListItemText primary="Choose From Gallery" />
                                    </ListItemButton>
                                  </List>
                                </Dialog>
                              )}

                              {/* UPLOAD BUTTON */}
                              {selectedImages[rowIndex] && (
                                <Button
                                  variant="contained"
                                  size="small"
                                  onClick={() =>
                                    handleImageClick(
                                      row,
                                      selectedImages[rowIndex]
                                    )
                                  }
                                  sx={{ fontSize: 10 }}
                                >
                                  Upload
                                </Button>
                              )}
                            </>
                          }
                        </>
                      ) : (
                        (colKey==="ohqty" && row["user_role"]==="Warehouse User")?"-":
                        colKey!=="user_role"&&row[colKey]
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
              {wareHouseMaterialData?.length === 0 && (
                <TableRow>
                  <TableCell
                    colSpan={wareHouseMaterialData.length}
                    sx={{ textAlign: "center" }}
                  >
                    {t("no_data")}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>
      </Card>
      {openCarousel && (
        <CCarousel
          cOpen={openCarousel}
          images={carouselImages}
          cClose={() => setOpenCarousel(false)}
        />
      )}
    </Grid>
  );
};

export default WareHouseView;
